<mat-card class="p-0">
  <mat-card-content>
    <ng-container *ngFor="let item of cartItems">
      <div class="row p-3" style="cursor: pointer" (click)="openProductDetail(item)">
        <div class="col col-img">
          <img *ngIf="item.image" [src]="item.image | fileUrl: 'products' : item.id" alt="" />
        </div>
        <div class="col">
          <b>{{ item.name }}</b
          ><br /><small>{{ item.count }}ks</small>
        </div>
        <div class="col-auto">
          <b>{{ item.count * item.price * vat | localeCurrency }}</b
          ><br /><small>{{ item.count * item.price | localeCurrency }}</small>
        </div>
      </div>
      <hr />
    </ng-container>
    <div class="row p-3">
      <div class="col"><b>Cena zboží:</b><br /><small>Cena zboží bez DPH:</small></div>
      <div class="col-auto">
        <b>{{ cartTotal | localeCurrency }}</b
        ><br /><small>{{ cartTotal / vat | localeCurrency }}</small>
      </div>
    </div>
    <hr />
    <div class="row p-3">
      <div class="col"><b>Způsob dopravy:</b><br />{{ delivery?.title }}</div>
      <div class="col-auto">
        <b>{{ delivery?.price ?? 0 | localeCurrency }}</b>
      </div>
    </div>
    <hr />
    <div class="row p-3">
      <div class="col"><b>Způsob platby:</b><br />{{ payment?.title }}</div>
      <div class="col-auto">
        <b>{{ payment?.price ?? 0 | localeCurrency }}</b>
      </div>
    </div>
    <div class="row row-price no-gutters">
      <div class="col p-3"><b>Celková cena:</b><br /><small>Celková cena bez DPH:</small></div>
      <div class="col-auto p-3">
        <b>{{ total | localeCurrency }}</b
        ><br /><small>{{ total / vat | localeCurrency }}</small>
      </div>
    </div>

    <ng-content></ng-content>

    <div *ngIf="showButtons" class="row pt-3">
      <div class="col">
        <button mat-stroked-button color="primary" (click)="back.emit()">
          <icon icon="arrow_back"></icon>&nbsp;&nbsp;{{ 'Back' | t }}
        </button>
      </div>
      <div class="col-auto">
        <button mat-raised-button color="primary" (click)="next.emit()">
          {{ continueLabel | t }}&nbsp;&nbsp;<icon icon="arrow_forward"></icon>
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
